// @material-ui/icons
import Group from '@material-ui/icons/Group';
import Home from '@material-ui/icons/Home';
import Train from '@material-ui/icons/Train';
import Landscape from '@material-ui/icons/Landscape';
import Report from '@material-ui/icons/LibraryBooks';
import Supervisors from '@material-ui/icons/SupervisedUserCircle';
import Users from '../views/users/components/Users';
import Skidata from '../views/skidata/components/Skidata';
import Mgb from '../views/skidata/components/Mgb';
import Bls from '../views/bls/components/Bls';
import Tenants from '../auth/Tenants';
import ZbagReport from '../views/skidata/components/ZbagReport';
import tenantRoles from '../auth/tenantRoles';
import BlsReport from '../views/bls/components/BlsReport';
import MgbReport from '../views/skidata/components/MgbReport';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import Shop from '../views/shop/components/Shop';
import App from '../views/app/components/App';
import StayCurrentPortrait from '@material-ui/icons/StayCurrentPortrait';
import HomePage from '../views/Pages/Home';

var dashRoutes = [
  {
    path: '/home',
    name: 'Home',
    mini: 'Ho',
    icon: Home,
    component: HomePage,
  },
  {
    path: '/users',
    name: 'Kunden',
    mini: 'KU',
    icon: Group,
    component: Users,
    roles: [tenantRoles.TENANT_ADMIN_WRITE],
  },
  {
    collapse: true,
    path: '/partner',
    name: 'Partner',
    mini: 'SD',
    state: 'partner',
    icon: Landscape,
    roles: [
      tenantRoles.SKIDATA_ADMIN_READ,
      tenantRoles.MGB_ADMIN_READ,
      tenantRoles.BLS_ADMIN_READ,
    ],
    views: [
      {
        path: '/partner/zbag',
        name: 'ZBAG',
        component: Skidata,
        roles: [tenantRoles.SKIDATA_ADMIN_READ],
      },
      {
        path: '/partner/mgb',
        name: 'MGB/GGB',
        component: Mgb,
        roles: [tenantRoles.MGB_ADMIN_READ],
      },
      {
        path: '/partner/bls',
        name: 'BLS',
        component: Bls,
        roles: [tenantRoles.BLS_ADMIN_READ],
      },
    ],
  },
  // {
  //   path: '/bls',
  //   name: 'BLS',
  //   mini: 'BLS',
  //   icon: Train,
  //   component: Bls,
  //   roles: [tenantRoles.BLS_ADMIN_READ],
  // },
  {
    path: '/tenants',
    name: 'Mandanten',
    mini: 'MA',
    icon: Supervisors,
    component: Tenants,
    roles: [tenantRoles.TENANT_ADMIN_WRITE],
  },
  {
    collapse: true,
    path: '/report',
    name: 'Reports',
    mini: 'RP',
    state: 'openReport',
    icon: Report,
    roles: [
      tenantRoles.SKIDATA_ADMIN_REPORT,
      tenantRoles.MGB_ADMIN_REPORT,
      tenantRoles.BLS_ADMIN_REPORT,
    ],
    views: [
      {
        path: '/report/dta',
        name: 'ZBAG',
        component: ZbagReport,
        roles: [tenantRoles.SKIDATA_ADMIN_REPORT],
      },
      {
        path: '/report/transport',
        name: 'BLS',
        component: BlsReport,
        roles: [tenantRoles.BLS_ADMIN_REPORT],
      },
      {
        path: '/report/mbg',
        name: 'MGB/GGB',
        component: MgbReport,
        roles: [tenantRoles.MGB_ADMIN_REPORT],
      },
    ],
  },
  {
    path: '/shop',
    name: 'Shop',
    mini: 'Shop',
    icon: ShoppingCart,
    component: Shop,
    roles: [tenantRoles.SKIDATA_ADMIN_WRITE],
  },
  {
    path: '/app',
    name: 'App',
    mini: 'App',
    icon: StayCurrentPortrait,
    component: App,
    roles: [tenantRoles.SUPER_ADMIN],
  },
  { redirect: true, path: '/', pathTo: '/home', name: 'Home' },
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx